// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/myprofile/v1/feature.proto (package gdx.gateway.web.myprofile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * If feature exists - user can't make more than 3 likes a day.
 * You can rely on `remain_count` to prevent extra likes from front.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeatureRestrictLikesLimit
 */
export class UserFeatureRestrictLikesLimit extends Message<UserFeatureRestrictLikesLimit> {
  /**
   * @generated from field: uint32 remain_count = 1;
   */
  remainCount = 0;

  constructor(data?: PartialMessage<UserFeatureRestrictLikesLimit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeatureRestrictLikesLimit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "remain_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeatureRestrictLikesLimit {
    return new UserFeatureRestrictLikesLimit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeatureRestrictLikesLimit {
    return new UserFeatureRestrictLikesLimit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeatureRestrictLikesLimit {
    return new UserFeatureRestrictLikesLimit().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeatureRestrictLikesLimit | PlainMessage<UserFeatureRestrictLikesLimit> | undefined, b: UserFeatureRestrictLikesLimit | PlainMessage<UserFeatureRestrictLikesLimit> | undefined): boolean {
    return proto3.util.equals(UserFeatureRestrictLikesLimit, a, b);
  }
}

/**
 * If feature exists - user can deal with `extended search` filters.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeatureAllowAdvancedSearch
 */
export class UserFeatureAllowAdvancedSearch extends Message<UserFeatureAllowAdvancedSearch> {
  constructor(data?: PartialMessage<UserFeatureAllowAdvancedSearch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeatureAllowAdvancedSearch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeatureAllowAdvancedSearch {
    return new UserFeatureAllowAdvancedSearch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeatureAllowAdvancedSearch {
    return new UserFeatureAllowAdvancedSearch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeatureAllowAdvancedSearch {
    return new UserFeatureAllowAdvancedSearch().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeatureAllowAdvancedSearch | PlainMessage<UserFeatureAllowAdvancedSearch> | undefined, b: UserFeatureAllowAdvancedSearch | PlainMessage<UserFeatureAllowAdvancedSearch> | undefined): boolean {
    return proto3.util.equals(UserFeatureAllowAdvancedSearch, a, b);
  }
}

/**
 * If feature exists - user can see websocket activity messages,
 * e.g. `somebody liked you` / `somebody visited your profile`, etc.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeatureAllowIncomingActivities
 */
export class UserFeatureAllowIncomingActivities extends Message<UserFeatureAllowIncomingActivities> {
  constructor(data?: PartialMessage<UserFeatureAllowIncomingActivities>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeatureAllowIncomingActivities";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeatureAllowIncomingActivities {
    return new UserFeatureAllowIncomingActivities().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeatureAllowIncomingActivities {
    return new UserFeatureAllowIncomingActivities().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeatureAllowIncomingActivities {
    return new UserFeatureAllowIncomingActivities().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeatureAllowIncomingActivities | PlainMessage<UserFeatureAllowIncomingActivities> | undefined, b: UserFeatureAllowIncomingActivities | PlainMessage<UserFeatureAllowIncomingActivities> | undefined): boolean {
    return proto3.util.equals(UserFeatureAllowIncomingActivities, a, b);
  }
}

/**
 * If feature exists - user can see likes page and likes activity without blur.
 * Also he can like / skip users on likes page.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeatureAllowWhoLikedYou
 */
export class UserFeatureAllowWhoLikedYou extends Message<UserFeatureAllowWhoLikedYou> {
  constructor(data?: PartialMessage<UserFeatureAllowWhoLikedYou>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeatureAllowWhoLikedYou";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeatureAllowWhoLikedYou {
    return new UserFeatureAllowWhoLikedYou().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeatureAllowWhoLikedYou {
    return new UserFeatureAllowWhoLikedYou().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeatureAllowWhoLikedYou {
    return new UserFeatureAllowWhoLikedYou().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeatureAllowWhoLikedYou | PlainMessage<UserFeatureAllowWhoLikedYou> | undefined, b: UserFeatureAllowWhoLikedYou | PlainMessage<UserFeatureAllowWhoLikedYou> | undefined): boolean {
    return proto3.util.equals(UserFeatureAllowWhoLikedYou, a, b);
  }
}

/**
 * If feature exists - user can unblock all profiles he blocked.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeatureAllowUnblockUser
 */
export class UserFeatureAllowUnblockUser extends Message<UserFeatureAllowUnblockUser> {
  constructor(data?: PartialMessage<UserFeatureAllowUnblockUser>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeatureAllowUnblockUser";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeatureAllowUnblockUser {
    return new UserFeatureAllowUnblockUser().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeatureAllowUnblockUser {
    return new UserFeatureAllowUnblockUser().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeatureAllowUnblockUser {
    return new UserFeatureAllowUnblockUser().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeatureAllowUnblockUser | PlainMessage<UserFeatureAllowUnblockUser> | undefined, b: UserFeatureAllowUnblockUser | PlainMessage<UserFeatureAllowUnblockUser> | undefined): boolean {
    return proto3.util.equals(UserFeatureAllowUnblockUser, a, b);
  }
}

/**
 * If feature exists - user can post only 1 message per dialog.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeatureRestrictMessagesLimit
 */
export class UserFeatureRestrictMessagesLimit extends Message<UserFeatureRestrictMessagesLimit> {
  constructor(data?: PartialMessage<UserFeatureRestrictMessagesLimit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeatureRestrictMessagesLimit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeatureRestrictMessagesLimit {
    return new UserFeatureRestrictMessagesLimit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeatureRestrictMessagesLimit {
    return new UserFeatureRestrictMessagesLimit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeatureRestrictMessagesLimit {
    return new UserFeatureRestrictMessagesLimit().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeatureRestrictMessagesLimit | PlainMessage<UserFeatureRestrictMessagesLimit> | undefined, b: UserFeatureRestrictMessagesLimit | PlainMessage<UserFeatureRestrictMessagesLimit> | undefined): boolean {
    return proto3.util.equals(UserFeatureRestrictMessagesLimit, a, b);
  }
}

/**
 * If feature exists - user can delete his chat messages.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeatureAllowDeleteOwnMessage
 */
export class UserFeatureAllowDeleteOwnMessage extends Message<UserFeatureAllowDeleteOwnMessage> {
  constructor(data?: PartialMessage<UserFeatureAllowDeleteOwnMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeatureAllowDeleteOwnMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeatureAllowDeleteOwnMessage {
    return new UserFeatureAllowDeleteOwnMessage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeatureAllowDeleteOwnMessage {
    return new UserFeatureAllowDeleteOwnMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeatureAllowDeleteOwnMessage {
    return new UserFeatureAllowDeleteOwnMessage().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeatureAllowDeleteOwnMessage | PlainMessage<UserFeatureAllowDeleteOwnMessage> | undefined, b: UserFeatureAllowDeleteOwnMessage | PlainMessage<UserFeatureAllowDeleteOwnMessage> | undefined): boolean {
    return proto3.util.equals(UserFeatureAllowDeleteOwnMessage, a, b);
  }
}

/**
 * If feature exists - user can watch extended info in other profiles.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeatureAllowAdvancedProfile
 */
export class UserFeatureAllowAdvancedProfile extends Message<UserFeatureAllowAdvancedProfile> {
  constructor(data?: PartialMessage<UserFeatureAllowAdvancedProfile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeatureAllowAdvancedProfile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeatureAllowAdvancedProfile {
    return new UserFeatureAllowAdvancedProfile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeatureAllowAdvancedProfile {
    return new UserFeatureAllowAdvancedProfile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeatureAllowAdvancedProfile {
    return new UserFeatureAllowAdvancedProfile().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeatureAllowAdvancedProfile | PlainMessage<UserFeatureAllowAdvancedProfile> | undefined, b: UserFeatureAllowAdvancedProfile | PlainMessage<UserFeatureAllowAdvancedProfile> | undefined): boolean {
    return proto3.util.equals(UserFeatureAllowAdvancedProfile, a, b);
  }
}

/**
 * If feature exists - user can see contents of activity section.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeatureAllowActivity
 */
export class UserFeatureAllowActivity extends Message<UserFeatureAllowActivity> {
  constructor(data?: PartialMessage<UserFeatureAllowActivity>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeatureAllowActivity";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeatureAllowActivity {
    return new UserFeatureAllowActivity().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeatureAllowActivity {
    return new UserFeatureAllowActivity().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeatureAllowActivity {
    return new UserFeatureAllowActivity().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeatureAllowActivity | PlainMessage<UserFeatureAllowActivity> | undefined, b: UserFeatureAllowActivity | PlainMessage<UserFeatureAllowActivity> | undefined): boolean {
    return proto3.util.equals(UserFeatureAllowActivity, a, b);
  }
}

/**
 * All possible user's feature.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserFeature
 */
export class UserFeature extends Message<UserFeature> {
  /**
   * @generated from oneof gdx.gateway.web.myprofile.v1.UserFeature.feature
   */
  feature: {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.UserFeatureRestrictLikesLimit restrict_likes_limit = 1;
     */
    value: UserFeatureRestrictLikesLimit;
    case: "restrictLikesLimit";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.UserFeatureAllowAdvancedSearch allow_advanced_search = 2;
     */
    value: UserFeatureAllowAdvancedSearch;
    case: "allowAdvancedSearch";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.UserFeatureAllowWhoLikedYou allow_who_liked_you = 3;
     */
    value: UserFeatureAllowWhoLikedYou;
    case: "allowWhoLikedYou";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.UserFeatureAllowUnblockUser allow_unblock_user = 4;
     */
    value: UserFeatureAllowUnblockUser;
    case: "allowUnblockUser";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.UserFeatureRestrictMessagesLimit restrict_messages_limit = 5;
     */
    value: UserFeatureRestrictMessagesLimit;
    case: "restrictMessagesLimit";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.UserFeatureAllowDeleteOwnMessage allow_delete_own_message = 6;
     */
    value: UserFeatureAllowDeleteOwnMessage;
    case: "allowDeleteOwnMessage";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.UserFeatureAllowAdvancedProfile allow_advanced_profile = 7;
     */
    value: UserFeatureAllowAdvancedProfile;
    case: "allowAdvancedProfile";
  } | {
    /**
     * @generated from field: gdx.gateway.web.myprofile.v1.UserFeatureAllowActivity allow_activity = 8;
     */
    value: UserFeatureAllowActivity;
    case: "allowActivity";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<UserFeature>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserFeature";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "restrict_likes_limit", kind: "message", T: UserFeatureRestrictLikesLimit, oneof: "feature" },
    { no: 2, name: "allow_advanced_search", kind: "message", T: UserFeatureAllowAdvancedSearch, oneof: "feature" },
    { no: 3, name: "allow_who_liked_you", kind: "message", T: UserFeatureAllowWhoLikedYou, oneof: "feature" },
    { no: 4, name: "allow_unblock_user", kind: "message", T: UserFeatureAllowUnblockUser, oneof: "feature" },
    { no: 5, name: "restrict_messages_limit", kind: "message", T: UserFeatureRestrictMessagesLimit, oneof: "feature" },
    { no: 6, name: "allow_delete_own_message", kind: "message", T: UserFeatureAllowDeleteOwnMessage, oneof: "feature" },
    { no: 7, name: "allow_advanced_profile", kind: "message", T: UserFeatureAllowAdvancedProfile, oneof: "feature" },
    { no: 8, name: "allow_activity", kind: "message", T: UserFeatureAllowActivity, oneof: "feature" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserFeature {
    return new UserFeature().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserFeature {
    return new UserFeature().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserFeature {
    return new UserFeature().fromJsonString(jsonString, options);
  }

  static equals(a: UserFeature | PlainMessage<UserFeature> | undefined, b: UserFeature | PlainMessage<UserFeature> | undefined): boolean {
    return proto3.util.equals(UserFeature, a, b);
  }
}

